<template>
  <SysDialog
    v-model="DIALOG_ATIVO_COMPUTED"
    titulo="Exportação Tateti"
    :largura="500"
    @click:hidden-dialog="resetarDialog"
  >
    <div class="d-flex w-full">
      <div class="w-50-porcento pr-2">
        <v-autocomplete
          label="Armazém"
          v-model="relatorio.armazem"
          :items="selects.armazem"
          outlined
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysDatePicker
          titulo_label="Data da Necessidade"
          v-model="relatorio.data_necessidade"
          outlined
          hide-details
        />
      </div>
    </div>

    <SysCodigosPagamentosAutocomplete
      label="Condição de Pagamento"
      v-model="relatorio.condicao_pagamento"
      outlined
      hide-details
      class="mt-5 mb-3"
    />

    <template #actions>
      <v-btn :disabled="!EXPORTACAO_ATIVA_COMPUTED" text color="primary" @click="gerarRelatorio">
        Gerar Relatório
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysDatePicker from "@/components/utils/SysDatePicker.vue";
import SysCodigosPagamentosAutocomplete from "@/components/utils/crud/SysCodigosPagamentosAutocomplete.vue";
import $axios from "@/api/api";

export default {
  components: {
    SysCodigosPagamentosAutocomplete,
    SysDatePicker,
    SysDialog
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    pedidoSelecionado: Object,
  },
  emits: ['update:modelValue'],
  data: () => ({
    selects: {
      armazem: ['01', '03']
    },
    relatorio: {
      armazem: '01',
      data_necessidade: '',
      condicao_pagamento: ''
    }
  }),
  computed: {
    DIALOG_ATIVO_COMPUTED: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    EXPORTACAO_ATIVA_COMPUTED() {
      return this.relatorio.armazem && this.relatorio.data_necessidade && this.relatorio.condicao_pagamento;
    }
  },
  methods: {
    gerarRelatorio() {
      if (!this.EXPORTACAO_ATIVA_COMPUTED) return;

      const url = $axios.defaults.baseURL.concat(
        '/relatorios/pedido-compra/tateti?',
        `idpedido=${this.pedidoSelecionado.idpedido}&`,
        `armazem=${this.relatorio.armazem}&`,
        `data_necessidade=${this.relatorio.data_necessidade}&`,
        `condicao_pagamento=${this.relatorio.condicao_pagamento}`,
      );

      window.open(url, "_blank");

      this.resetarDialog();
    },
    resetarDialog() {
      this.DIALOG_ATIVO_COMPUTED = false;
      this.relatorio.armazem = '01';
      this.relatorio.data_necessidade = '';
      this.relatorio.condicao_pagamento = '';
      this.$emit('reset-exportacao-tateti');
    }
  }
}
</script>
